import * as types from 'models/actionTypes'
import { AnyAction } from 'redux'

const initialState = {
    kioskSelectedRoomType: null,
    isKioskIntroViewed: false,
}

const kiosk = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case types.SELECT_KIOSK_ROOM_TYPE:
            return {
                ...state,
                kioskSelectedRoomType: action.roomType,
            }
        case types.SET_KIOSK_INTRO_VIEWED:
            return {
                ...state,
                isKioskIntroViewed: true,
        }
        default:
            return state
    }
}

export default kiosk
